import React from 'react';
import PropTypes from 'prop-types';

import { Anchor, Text } from '@zillow/constellation';

const propTypes = {
    styledTextList: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired,
        styling: PropTypes.string,
        url: PropTypes.string,
    })),
    fontColor: PropTypes.string,
};

const defaultProps = {
    styledTextList: [],
    fontColor: 'gray600',
};

const TEXT_STYLING = {
    legal: 'legal',
    normal: 'smallbody',
    emphasize: 'smalllabel',
};

const InlineStyledText = ({ styledTextList, fontColor }) => {
    const getInnerText = ({ text, url }) => {
        if (url) {
            return <Anchor href={url}>{text}</Anchor>;
        }

        return text;
    };

    if (!styledTextList || !styledTextList.length) {
        return null;
    }

    return (
        <div data-test="inline-styled-text">
            {styledTextList.map((styledText, index) => (
                <Text
                    key={`inlinedStyledText-${index}`}
                    fontType={styledText.styling ?
                        TEXT_STYLING[styledText.styling]
                        :
                        'body'
                    }
                    fontColor={fontColor}
                >
                    {getInnerText(styledText)}
                </Text>
            )) }
        </div>
    );
};

InlineStyledText.propTypes = propTypes;
InlineStyledText.defaultProps = defaultProps;

export default InlineStyledText;
